import { render, staticRenderFns } from "./AppStoreInput.vue?vue&type=template&id=2dd96a38"
import script from "./AppStoreInput.vue?vue&type=script&lang=js"
export * from "./AppStoreInput.vue?vue&type=script&lang=js"
import style0 from "./AppStoreInput.vue?vue&type=style&index=0&id=2dd96a38&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports